import { useCallback } from "react";

import type { OptionPmsItemCancelInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Query from "../../query";
import * as Schema from "../schema";

export const useOptionPmsItemCancelMutation = () => {
	const { mutationFunc } = useCustomMutation(Schema.OPTION_PMS_ITEM_CANCEL_FOR_OPTION_PMS_MUTATION);

	const onCancelOptionPmsItem = useCallback(
		async (input: OptionPmsItemCancelInput) =>
			mutationFunc({
				variables: { input },
				refetchQueries: [Query.Schema.OPTION_PMS_ACTIVE_LIST_FOR_OPTION_PMS],
			}),
		[mutationFunc],
	);

	return { onCancelOptionPmsItem };
};
